import cn from 'classnames';
import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import TrustedShopReviewCarousel from 'components/trusted-shop-review-carousel';
import { FeatureFlag, getFeatureFlag } from 'constants/feature-flag';
import useExperiment from 'hooks/common/use-experiment';
import useMobile from 'hooks/common/use-mobile';
import StandaloneCDP from 'modules/collection/components/standalone-cdp';
import PromoBarSmall from 'modules/content-cms/sections/promo-bar-small';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import BowlImage from '../../assets/bowl-image.jpeg';
import FubeEntryPoint from '../fube-entry-point';
import InfluencerCollectionSlider from '../influencer-colletion-slider';
import LandingPageCollectionSlider from '../landing-page-collection-slider';
import ModalInformation from '../modal-information';
import NeedBreedSelector from '../need-breed-selector';
import SpecialAndLimitedEditionSlider from '../special-and-limited-edition-slider';
import UspSection from '../usp-section';
import fubeEntryImage from './fube-entry-cat.jpeg';

/**
 * Cat home page experience for new customer
 */
const LandingPageForNewCustomer: React.FC = () => {
  const fubeFlg = getFeatureFlag(FeatureFlag.fube);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useMobile();

  const { variant, loading: testLoading } = useExperiment({
    baseEntryId: '6YLPFV2zhqxNDfEE6AfdNc',
  });

  return (
    <>
      <InfluencerCollectionSlider className="lg:mb-0" />
      <PromoBarSmall />
      {/* top part  */}
      <div className="relative bg-cat-base">
        <h1 className="mb-1 mt-8 whitespace-pre-wrap text-center text-text-dark-bg-primary mindset-48 lg:mb-2.5 lg:mt-16 lg:mindset-80">
          <FormattedMessage id="landingpage:home:home:title" />
        </h1>
        <div>
          <NeedBreedSelector isMobile={isMobile} petType="cat" />
        </div>
      </div>

      {/* USP section  */}
      <UspSection image={BowlImage} petType="cat" />

      {/* landing collection slider  */}
      {getFeatureFlag(FeatureFlag.segmentation) && (
        <div className="container  mt-8 overflow-hidden first-line:mb-6 lg:my-16 lg:overflow-visible">
          <LandingPageCollectionSlider
            elementNameTracking={['Individual Needs', 'Options']}
            petType={'cats'}
            title="landingpage:home:slider:headline"
          />
        </div>
      )}

      {/* Fube entry part  */}
      {fubeFlg && <FubeEntryPoint image={fubeEntryImage} petType="cats" />}

      {!testLoading && variant === 1 && (
        <TrustedShopReviewCarousel location="Home Cat" />
      )}

      {/* Limited section  */}
      <ImpressionTrackerNew
        element={['Highlights', 'probierpakete-fur-katzen']}
      >
        <div className="bg-background-default">
          <div className="container my-6 lg:my-16">
            <SpecialAndLimitedEditionSlider
              collectionHandle="probierpakete-fur-katzen"
              elementNameTracking="Highlights"
              title="landingpage:home:dog-cat:slider:headline"
            />
          </div>
        </div>
      </ImpressionTrackerNew>

      <StandaloneCDP
        bestsellerSectionClassName="-mx-4!"
        className={cn('my-6 lg:my-16', isMobile ? 'px-4' : 'container')}
        collectionHandle="fur-katzen-alle-fleischsorten"
        subTitle="landingpage:standalone-cdp:nc-cat:sub-headline"
        title="landingpage:standalone-cdp:headline"
        showMoreButton
        productsLimit={6}
      />

      <ModalInformation isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
    </>
  );
};

export default LandingPageForNewCustomer;
